"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("@emotion/css");
exports.default = {
    dock: (0, css_1.css)({
        'fontFamily': 'Helvetica Neue',
        '@media (min-width: 0px) and (max-width: 450px)': {
            display: 'none',
        },
    }),
    draggable: (0, css_1.css)({
        position: 'fixed',
        right: '0px',
        top: '100px',
    }),
};
